import { IFilters } from "api";
import { queryStringBuilder } from "helpers/globalFunctions";

import { handleApiGet } from "./api";
import { BackendUrl } from "./newBackendApi";

export function fullSearch(token: string, query: string) {
  return handleApiGet(
    `${BackendUrl}/admin/filter/data${query}&sort=createdAt:desc`,
    { Authorization: token },
  );
}

// new BE

export function getTypeData(token: string, opts: IFilters) {
  const query = queryStringBuilder(opts);
  const filterUrl = `${BackendUrl}/admin/filter/data${query}`;
  const headers: Record<string, string> = {};
  headers.Authorization = token;
  return handleApiGet(filterUrl, headers);
}
export function getTypeCount(token: string, opts?: IFilters) {
  const query = queryStringBuilder(opts);
  const headers: Record<string, string> = {};
  headers.Authorization = token;
  return handleApiGet(`${BackendUrl}/admin/filter/total${query}`, headers);
}
